//imgs
import img01 from "../../assets/images/chapters/09/01.jpg";

import img02 from "../../assets/images/chapters/09/02.jpg";
import img03 from "../../assets/images/chapters/09/03.jpg";
import img04 from "../../assets/images/chapters/09/04.jpg";
import img05 from "../../assets/images/chapters/09/05.jpg";
import img06 from "../../assets/images/chapters/09/06.jpg";

import img07 from "../../assets/images/chapters/09/07.jpg";
import img08 from "../../assets/images/chapters/09/08.jpg";
import img09 from "../../assets/images/chapters/09/09.jpg";
import img10 from "../../assets/images/chapters/09/10.jpg";

import img28 from "../../assets/images/chapters/09/28.jpg";

import { captions, list, list2 } from "../../assets/data/chapters/chapter09";

//scroll reveal
import ScrollReveal from "../scrollReveal";

const Chapter = () => {
  return (
    <div id="chapter09">
      <div className="group01">
        <ScrollReveal className="title">
          <div className="column">
            <span>PSEP</span>
            <span>PSEP</span>
            <span>PSEP</span>
            <p className="caption">{captions[0]}</p>
          </div>
        </ScrollReveal>

        <ScrollReveal className="title">
          <div className="column">
            <span>LRRR</span>
            <span>LRRR</span>
            <span>LRRR</span>
            <p className="caption">{captions[1]}</p>
          </div>
        </ScrollReveal>

        <div className="row">
          <ScrollReveal className="picture">
            <img src={img01} />
          </ScrollReveal>
        </div>
      </div>

      <div className="group02">
        <div className="row">
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img02} />
              <p className="caption">{captions[2]}</p>
            </ScrollReveal>
            <ScrollReveal className="picture">
              <img src={img03} />
            </ScrollReveal>
          </div>
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img04} />
            </ScrollReveal>
            <ScrollReveal className="picture">
              <img src={img05} />
            </ScrollReveal>
          </div>
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img06} />
              <p className="caption">{captions[3]}</p>
            </ScrollReveal>
          </div>
        </div>
      </div>

      <div className="group03">
        <ScrollReveal className="picture">
          <img src={img07} />
        </ScrollReveal>
        <ScrollReveal className="picture">
          <img src={img08} />
        </ScrollReveal>
        <ScrollReveal className="picture">
          <img src={img09} />
          <p className="caption">{captions[4]}</p>
        </ScrollReveal>
        <ScrollReveal className="picture">
          <img src={img10} />
          <p className="caption">{captions[5]}</p>
        </ScrollReveal>
      </div>

      <div className="group04">
        <div className="row">
          {list.map((elem) => (
            <ScrollReveal className="picture">
              <img src={elem.img} />
              {elem.caption && <p className="caption">{elem.caption}</p>}
            </ScrollReveal>
          ))}
          <div className="column">
            {list2.map((elem) => (
              <ScrollReveal className="picture ">
                <img src={elem.img} />
                {elem.caption && <p className="caption">{elem.caption}</p>}
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
      <div className="group05">
        <ScrollReveal className="title">
          <span>
            CORE-tube{"\n"}
            sample
          </span>
        </ScrollReveal>
        <ScrollReveal className="picture">
          <img src={img28} alt="" />
        </ScrollReveal>
      </div>
    </div>
  );
};

export default Chapter;
